import React from 'react';
import TwoButtonModal from './base/TwoButtonModal.js';
import AddModal from './templates/AddModal.js';
import ConfirmationModal from './templates/ConfirmationModal.js';
import DeleteModal from './templates/DeleteModal.js';
import EditModal from './templates/EditModal.js';
import InformationModal from './templates/InformationModal.js';
import UploadModal from './templates/UploadModal.js';
import CancelButton from './buttons/CancelButton.js';
import SubmitButton from './buttons/SubmitButton.js';

/**
 * A standard two-button modal
 */
var Modal = function Modal(props) {
  return /*#__PURE__*/React.createElement(TwoButtonModal, props);
}; // bundle related sub-components

/** A modal template for performing an add operation */


Modal.Add = AddModal;
/** A modal template for confirming some action */

Modal.Confirmation = ConfirmationModal;
/** A modal template for performing a delete operation */

Modal.Delete = DeleteModal;
/** A modal template for performing an edit operation */

Modal.Edit = EditModal;
/** A modal template for displaying some information */

Modal.Information = InformationModal;
/** A modal template for uploading a file */

Modal.Upload = UploadModal;
/** A button for cancelling a modal */

Modal.CancelButton = CancelButton;
/** A button for submitting a modal */

Modal.SubmitButton = SubmitButton;
var Modal$1 = Modal;

export { Modal$1 as default };
